export const WarehouseRouting = [
  {
    path: "/material/warehouse/list",
    name: "basic-material-warehouse-list",
    meta: { title: "入库单" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/warehouse/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/warehouse/create",
    name: "basic-material-warehouse-create",
    meta: { title: "新增入库单" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/warehouse/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/warehouse/edit/:id",
    name: "basic-material-warehouse-edit",
    meta: { title: "编辑入库单" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/warehouse/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/warehouse/detail/:id",
    name: "basic-material-warehouse-detail",
    meta: { title: "入库单详情" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/warehouse/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/warehouse/flowPrint/:id",
    name: "material-material-warehouse-flowPrint",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "tender-quote" */ "@/views/material/warehouse/flow-print/index.vue"
      ),
  },
];
